import { BreathworkDifficultyLevel } from './Breathwork';

export interface Filters {
  selectedActivitiesIds: string[];
  selectedBenefitIds: string[];
  selectedDifficulties: BreathworkDifficultyLevel[];
}

export function emptyFilters(): Filters {
  return { selectedActivitiesIds: [], selectedBenefitIds: [], selectedDifficulties: [] };
}

export function hasNoFilters(filters: Filters): boolean {
  return (
    filters.selectedActivitiesIds.length === 0 &&
    filters.selectedBenefitIds.length === 0 &&
    filters.selectedDifficulties.length === 0
  );
}
